module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.sidebarActiveButton === 'advancedconfig',
      disabled: _vm.boxConfig.advanced.view_mode === 'click'
    },
    attrs: {
      "title": "Config."
    },
    on: {
      "click": function($event) {
        return _vm.handleClick()
      }
    }
  }, [_c('i', {
    staticClass: "icon-kp-config"
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-f23673ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/buttons/types/AdvancedConfig.vue
 ** module id = 924
 ** module chunks = 1
 **/